import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { environment } from '../environments/environment';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { TranslationService } from './services/translation.service';
import { RtlService } from './services/rtl.service';
import { LanguageNavigationService } from './services/language-navigation.service';
import { ErrorReportingService } from './services/error-reporting.service';
import { GlobalErrorHandler } from './services/global-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      // Restore the history position when a CanDeactivate guard cancels a back
      // navigation, so a declined exit-test prompt leaves the URL in sync.
      withRouterConfig({ canceledNavigationResolution: 'computed' })
    ),
    provideHttpClient(),
    provideAnimationsAsync(),
    provideLottieOptions({
      player: () => player,
    }),

    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    TranslationService,
    RtlService,
    LanguageNavigationService,
    // Remote visibility into uncaught client errors (web + native webview).
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [ErrorReportingService],
      useFactory: (svc: ErrorReportingService) => () => svc.init(),
    },
  ],
};
